import { FC } from 'react';
import { Error } from '@doda/io-react/common';
import styles from './index.module.scss';
import { ValidationErrorType } from '../../interface';

/**
 * Propsの定義
 * @param validationError バリデーションエラーのフラグ
 */
interface Props {
  validationError: ValidationErrorType;
}

/**
 * 求人検索トップ画面 バリデーションエラーのテキスト
 */
export const ValidationErrorText: FC<Props> = ({ validationError }) => {
  return (
    <div className={styles.conditionChange__validationErrorTextList}>
      {validationError.isErrorNonCondition && (
        <p className={styles.conditionChange__validationErrorTextList__item}>
          <Error size="M" />
          求人検索条件を入力してください。
        </p>
      )}
      {validationError.isErrorConditionUpperLimit && (
        <p className={styles.conditionChange__validationErrorTextList__item}>
          <Error size="M" />
          検索条件は60個を超えて設定できません。
        </p>
      )}
    </div>
  );
};
